import React from "react";
import styles from "./BlackFridayBanner.module.scss";
import { useNavigate } from 'react-router-dom';

import botLeft1 from 'images/Game City Rewards/Christmas/_0010_Christmas-Gift.png';
import botLeft2 from 'images/Game City Rewards/Christmas/_0012_Christmas-Reindeer.png';
import botLeft3 from 'images/Game City Rewards/Christmas/_0013_Christmas-Snowman.png';
import botRight1 from 'images/Game City Rewards/Christmas/_0014_Christmas-Bear.png';
import botRight2 from 'images/Game City Rewards/Christmas/_0015_Christmas-Gingerbread.png';
import botRight3 from 'images/Game City Rewards/Christmas/_0016_Christmas-Santa.png';

const BlackFridayBanner = ({ showButton = true, shrinkAvatars = false }) => {
 
    const navigate = useNavigate();

    const ribbonText = Array(10).fill("BLACK FRIDAY DEAL").map((text, index) => (
        <span key={index} className={styles.ribbonText}>
            {text} <span className={styles.dot}>&#8226;</span>
        </span>
    ));

    const isMobileWidth = () => {
        return window.innerWidth < 500;
    }

    return (
        <div className={`${styles.blackFridayBanner}`}>
            <img className={`${styles.bot} ${styles.left} ${styles.three} ${shrinkAvatars && styles.small}`} src={botLeft3} alt="bot-left" />
            <img className={`${styles.bot} ${styles.left} ${styles.two} ${shrinkAvatars && styles.small}`} src={botLeft2} alt="bot-left" />
            <img className={`${styles.bot} ${styles.left} ${styles.one} ${shrinkAvatars && styles.small}`} src={botLeft1} alt="bot-left" />

            <img className={`${styles.bot} ${styles.right} ${styles.three} ${shrinkAvatars && styles.small}`} src={botRight3} alt="bot-right" />
            <img className={`${styles.bot} ${styles.right} ${styles.two} ${shrinkAvatars && styles.small}`} src={botRight2} alt="bot-right" />
            <img className={`${styles.bot} ${styles.right} ${styles.one} ${shrinkAvatars && styles.small}`} src={botRight1} alt="bot-right" />
            {!isMobileWidth() &&
                <div className={styles.ribbon}>
                    <div className={styles.ribbonContent}> {ribbonText}{ribbonText} </div>
                </div>
            }
            <h2 className={styles.title}>BLACK FRIDAY 50% OFF!</h2>
            <p className={styles.description}>
                Use Code <strong>FRIDAY50</strong> and grab yourself <strong>50% OFF ALL GAMES!</strong>
            </p>

            {showButton && <button onClick={() => navigate("/shop")} className={`${styles.button} ${styles.alternate} ${styles.wide}`}>SHOP & SAVE</button>}

        </div>
    );
};

export default BlackFridayBanner;